import { useChannelsContext } from 'modules/channels/contexts';
import { ChannelBinding } from 'modules/channels/types';
import { calculatePercentage } from 'modules/channels/utils';
import { useState } from 'react';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';
import { StyledBanner } from '../Styled';

export const PercentageBanner = ({ channelBindings }: { channelBindings: ChannelBinding[] }) => {
  const [total, setTotal] = useState(100);

  const { espAccounts } = useChannelsContext();
  const defaultAccount = espAccounts?.find((account) => account.isDefault);

  const percentageMessage = `Remaining ${100 - total}% of sends will default to ${
    defaultAccount?.name || 'the Iterable Shared Pool'
  }.`;

  useDebouncedEffect(
    () => {
      setTotal(calculatePercentage(channelBindings));
    },
    [channelBindings],
    { debounceTimeout: 500 },
  );

  return <>{total < 100 && <StyledBanner>{percentageMessage}</StyledBanner>}</>;
};
